import '../applied_filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedLanguageView extends Monitoring.Views.SocialContents.Filters.AppliedFilterView
  name: 'languages'

  removeFilter: (value) ->
    @searchQuery.removeLanguage(value)